import { ProviderContext, withSnackbar } from "notistack";
import useModal from "../Modals/UseModal";
import React, { useState } from "react";
import { AccordionDetails, IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { NavLink } from "react-router-dom";
import DeleteClassModal from "../Modals/DeleteClassModal";
import EditClassModal from "../Modals/EditClassModal";
import "./TeacherSidebarTile.css";

interface TeacherTileProps {
  classId: string;
  className: string;
  grade: string;
}

const TeacherSidebarTile = (props: TeacherTileProps & ProviderContext) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const overflowOpen = Boolean(anchorEl);

  const handleOverflowClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOverflowClose = () => {
    setAnchorEl(null);
  };

  const { open: deleteOpen, openModal: openDeleteModal, closeModal: closeDeleteModal } = useModal(false);
  const { open: editOpen, openModal: openEditModal, closeModal: closeEditModal } = useModal(false);
  const [userHovering, setHover] = useState(false);

  const handleCloseEditModal = () => {
    handleOverflowClose();
    closeEditModal();
  };

  const handleCloseDeleteModal = () => {
    handleOverflowClose();
    closeDeleteModal();
  };

  return (
    <div className="TeacherSidebarTile">
      <AccordionDetails
        className="classLinkContainer"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <NavLink to={`/Class/${props.classId}`} className="navLink">
          <span className="ClassName" title={props.className}>
            {props.className}
          </span>
        </NavLink>
        <IconButton
          size="small"
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleOverflowClick}
          style={{ opacity: userHovering ? "100%" : "0" }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>

        <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={overflowOpen} onClose={handleOverflowClose}>
          <MenuItem key="edit" selected={editOpen} onClick={openEditModal}>
            Edit Class
          </MenuItem>
          <MenuItem key="delete" selected={deleteOpen} onClick={openDeleteModal}>
            Delete Class
          </MenuItem>
        </Menu>
      </AccordionDetails>
      <EditClassModal
        open={editOpen}
        cancelClose={handleCloseEditModal}
        classId={props.classId}
        className={props.className}
        grade={props.grade}
      />
      <DeleteClassModal
        open={deleteOpen}
        cancelClose={handleCloseDeleteModal}
        classId={props.classId}
        className={props.className}
      />
    </div>
  );
};

export default withSnackbar(TeacherSidebarTile);
